import React, { useState } from 'react';
import './Register.css';

const Register = ({ switchToLogin }) => {
  // Estados para los campos del formulario y los mensajes
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    // Validación simple de contraseña
    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }

    try {
      // Hacemos la petición POST a nuestro endpoint de registro
      const response = await fetch('https://api.interventorsisgafr.com/api/usuarios/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        // Si el backend devuelve un error (ej: email duplicado), lo mostramos
        throw new Error(data.msg || 'Error al registrar el usuario.');
      }

      // Si el registro es exitoso
      setSuccessMessage('¡Usuario registrado con éxito! Por favor, inicia sesión.');
      // Limpiamos los campos después de un registro exitoso
      setEmail('');
      setPassword('');

      // Opcional: Redirigir al login después de unos segundos
      setTimeout(() => {
        switchToLogin();
      }, 2000);

    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="register-container">
      <h2>Crear Cuenta</h2>
      <form onSubmit={handleSubmit}>
        {/* Mostramos mensajes de error o éxito */}
        {error && <p className="error-message">{error}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        {/* El campo "Nombre Completo" se omite por ahora */}
        <div className="form-group">
          <label htmlFor="email">Correo Electrónico</label>
          <input 
            type="email" 
            id="email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Contraseña (mín. 6 caracteres)</label>
          <input 
            type="password" 
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
        </div>
        <button type="submit" className="submit-btn">Registrarse</button>
      </form>
      <p>
        ¿Ya tienes una cuenta? <button type="button" onClick={switchToLogin} className="switch-btn">Inicia Sesión</button>
      </p>
    </div>
  );
};

export default Register;